import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqTopicsComponent } from './faq-topics/faq-topics.component';
import { FaqTopicComponent } from './faq-topic/faq-topic.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {DropzoneModule} from 'ngx-dropzone-wrapper';
import { FaqQuestionsComponent } from './faq-questions/faq-questions.component';
import { FaqQuestionComponent } from './faq-question/faq-question.component';
import {DragulaModule} from 'ng2-dragula';
import {EditorModule} from '@tinymce/tinymce-angular';

@NgModule({
  declarations: [FaqTopicsComponent, FaqTopicComponent, FaqQuestionsComponent, FaqQuestionComponent],
  imports: [
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      DropzoneModule,
      DragulaModule.forRoot(),
      EditorModule,
  ]
})
export class FaqModule { }
